<script>
  const { fillColor = "#000" } = $props();
</script>
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.414 6L17 3.414L15.586 2L12 5.586L8.414 2L7 3.414L9.586 6H2V13H4V22H20V13H22V6H14.414ZM11 20H6V13H11V20ZM11 11H4V8H11V11ZM18 20H13V13H18V20ZM20 11H13V8H20V11Z" fill={fillColor} />
</svg>
